import { ETrackingEventsName } from '../../models/Tracking.interfaces';

function getTrackingJSON(type: ETrackingEventsName, data: any) {
    try {
        let jsonRequest_apiRequest = require('./json-interfaces/navigationTracking-apiRequest.json');
        let jsonRequest_screenView = require('./json-interfaces/navigationTracking-screenView.json');
        let jsonRequest_userInteraction = require('./json-interfaces/navigationTracking-userInteraction.json');
        let jsonResults = {};
        switch (type) {
            //Mode Api-Request
            case 'api-request': {
                jsonRequest_apiRequest.data.data = data;
                jsonResults = jsonRequest_apiRequest;
                break;
            }
            case 'screen-view': {
                jsonRequest_screenView.data.data = data;
                jsonResults = jsonRequest_screenView;
                break;
            }
            case 'user-interaction': {
                jsonRequest_userInteraction.data.data = data;
                jsonResults = jsonRequest_userInteraction;
                break;
            }
            default: {
                break;
            }
        }
        return JSON.stringify(jsonResults);
    } catch (error) {
        console.error(error);
    }
}

export default getTrackingJSON;
